"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = _interopRequireDefault(require("./styles"));
var _Highlight = _interopRequireDefault(require("../../api/Highlight"));
var _Auth = require("../../contexts/Auth");
var _core = require("@material-ui/core");
var _Highlight2 = require("../../constants/Highlight");
var _icons = require("@material-ui/icons");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _Highlight3 = require("../../contexts/Highlight");
var _utils = require("../../utils");
var _ColorPopover = _interopRequireDefault(require("../ColorPopover"));
var _HighlightList = require("../../contexts/HighlightList");
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function HighlightListItem(props) {
  var {
    highlight,
    annotationRef,
    handleCopyButtonClick
  } = props;
  var [menuAnchorEl, setMenuAnchorEl] = (0, _react.useState)();
  var [annotationFocus, setAnnotationFocus] = (0, _react.useState)(false);
  var [annotation, setAnnotation] = (0, _react.useState)(highlight.annotation);
  var classes = (0, _styles.default)();
  var {
    auth
  } = (0, _Auth.useAuth)();
  var {
    dispatch,
    ACTION,
    setFocus: setHighlightFocus
  } = (0, _Highlight3.useHighlight)();
  var {
    applicationToken,
    sessionToken
  } = auth;
  var [selectedHighlight, setSelectedHighlight] = (0, _react.useState)();
  var [openDeleteModal, setOpenDeleteModal] = (0, _react.useState)();
  var {
    setFocus
  } = (0, _HighlightList.useHighlightList)();
  var tracking = (0, _Trackings.default)(auth);
  var {
    uuid,
    bookTitle
  } = auth;
  function getColor() {
    return Object.values(_Highlight2.COLOR).find(color => color.id === highlight.color);
  }
  function onClickHighlight() {
    setHighlightFocus(highlight);
    props.onClickHighlight(highlight);
  }
  function onUpdateHighlight(_x) {
    return _onUpdateHighlight.apply(this, arguments);
  }
  function _onUpdateHighlight() {
    _onUpdateHighlight = _asyncToGenerator(function* (newHighlight) {
      setMenuAnchorEl();
      var payload = {
        color: newHighlight.color,
        annotation: newHighlight.annotation
      };
      var data = yield _Highlight.default.update(applicationToken, sessionToken, newHighlight.id, payload);
      var value = _objectSpread(_objectSpread({}, data), newHighlight);
      onTrackingHighlight(highlight, value);
      dispatch({
        type: ACTION.UPDATE,
        payload: value
      });
    });
    return _onUpdateHighlight.apply(this, arguments);
  }
  function onTrackingHighlight(highlight, newHighlight) {
    if (highlight.color !== newHighlight.color) {
      tracking.trackColorHighlightEdit({
        uuid,
        titleCover: bookTitle,
        color: newHighlight.color,
        id: newHighlight.id,
        highlight: newHighlight.text_highlighted
      });
    }
    if (!highlight.annotation) {
      tracking.trackAddBooknote({
        uuid,
        titleCover: bookTitle,
        origin: 'adicionou uma nota',
        color: newHighlight.color,
        id: newHighlight.id,
        booknote: newHighlight.annotation ? 'yes' : 'no',
        highlight: newHighlight.text_highlighted
      });
    } else if (highlight.annotation !== newHighlight.annotation) {
      tracking.trackEditHighlight({
        uuid,
        titleCover: bookTitle,
        origin: newHighlight.annotation ? 'editou a nota' : 'excluiu a nota',
        highlight: newHighlight.id,
        booknote: newHighlight.annotation ? 'yes' : 'no'
      });
    }
  }
  function onDelete() {
    setMenuAnchorEl();
    _Highlight.default.remove(applicationToken, sessionToken, highlight.id);
    tracking.trackDeleteHighlight(_objectSpread(_objectSpread({}, highlight), {}, {
      uuid,
      titleCover: bookTitle
    }));
    dispatch({
      type: ACTION.DELETE,
      payload: highlight
    });
    setOpenDeleteModal(false);
  }
  function onDeleteModal() {
    setOpenDeleteModal(true);
    setMenuAnchorEl();
  }
  function onBlurAnnotation() {
    setAnnotationFocus(false);
    if (highlight.annotation !== annotation) {
      onUpdateHighlight(_objectSpread(_objectSpread({}, highlight), {}, {
        annotation
      }));
    }
  }
  function onColorPopover() {
    setMenuAnchorEl();
    setSelectedHighlight(highlight);
  }
  function onEditNote() {
    setMenuAnchorEl();
    setFocus(highlight);
  }
  function onCopy() {
    setMenuAnchorEl();
    setTimeout(() => {
      handleCopyButtonClick(highlight);
    }, 200);
  }
  function renderDesktopColor() {
    return /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
      cascade: true,
      label: "Alterar cor",
      className: classes.menu,
      icon: /*#__PURE__*/_react.default.createElement(_icons.ColorLens, {
        className: classes.menuIcon
      })
    }, Object.values(_Highlight2.COLOR).filter(color => color.id !== highlight.color).map(color => /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
      key: color.id,
      onClick: () => onUpdateHighlight(_objectSpread(_objectSpread({}, highlight), {}, {
        color: color.id
      }))
    }, color.label)));
  }
  function renderMobileColor() {
    return /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
      onClick: onColorPopover,
      icon: /*#__PURE__*/_react.default.createElement(_icons.ColorLens, {
        className: classes.menuIcon
      })
    }, "Alterar cor");
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.item
  }, /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    className: classes.itemHeader,
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    className: classes.title,
    primary: highlight.title
  }), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.itemMenu,
    onClick: e => setMenuAnchorEl(e.target)
  }, /*#__PURE__*/_react.default.createElement(_icons.MoreVert, null))), /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    button: true,
    onClick: onClickHighlight
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    style: {
      backgroundColor: getColor().hex
    }
  }, highlight.text_highlighted)), /*#__PURE__*/_react.default.createElement(_core.ListItem, null, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    className: annotation && !annotationFocus ? classes.savedTextField : '',
    label: (!annotation || annotationFocus) && 'Adicionar Nota',
    variant: "outlined",
    fullWidth: true,
    multiline: true,
    maxRows: 4,
    onFocus: () => setAnnotationFocus(true),
    onBlur: onBlurAnnotation,
    value: annotation || '',
    onChange: e => setAnnotation(e.target.value),
    inputRef: annotationRef
  })), /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    className: classes.actions
  }, annotationFocus && /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary"
  }, "Salvar")), /*#__PURE__*/_react.default.createElement(_ColorPopover.default, {
    highlight: selectedHighlight,
    setHighlight: setSelectedHighlight,
    onUpdate: highlight => dispatch({
      type: ACTION.UPDATE,
      payload: highlight
    })
  }), /*#__PURE__*/_react.default.createElement(_saraivaUi.Menu, {
    open: Boolean(menuAnchorEl),
    anchorEl: menuAnchorEl,
    onClose: () => setMenuAnchorEl(),
    className: classes.menu,
    placement: "bottom-end"
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
    onClick: () => onCopy(),
    icon: /*#__PURE__*/_react.default.createElement(_icons.FileCopy, {
      className: classes.menuIcon
    })
  }, "Copiar"), /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
    onClick: onEditNote,
    icon: /*#__PURE__*/_react.default.createElement(_icons.Create, {
      className: classes.menuIcon
    })
  }, "Editar Nota"), (0, _utils.getDeviceType)() === 'desktop' ? renderDesktopColor() : renderMobileColor(), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.menuItemDivider
  }), /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
    onClick: onDeleteModal,
    icon: /*#__PURE__*/_react.default.createElement(_icons.Delete, {
      className: classes.menuIcon
    })
  }, "Excluir")), /*#__PURE__*/_react.default.createElement(_saraivaUi.Dialog, {
    title: "Excluir nota e destaque",
    open: openDeleteModal,
    secondaryButton: "Cancelar",
    primaryButton: "Excluir",
    handleClose: () => setOpenDeleteModal(false),
    handleConfirm: onDelete,
    confirmWithoutCheck: onDelete
  }, "Deseja excluir esta nota e destaque?"));
}
var _default = exports.default = HighlightListItem;